import { Dd, Dl, Dt } from '@talos/kyoko';
import type { ComponentProps, ReactNode } from 'react';

export function OrderSummaryItem({
  title,
  children,
  ...props
}: { children: ReactNode; title: ReactNode } & Omit<ComponentProps<typeof Dl>, 'children' | 'title'>) {
  return (
    <Dl alignItems="stretch" {...props}>
      <Dt fontSize="fontSizeTiny">{title}</Dt>
      <Dd mt="spacing4" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
        {children}
      </Dd>
    </Dl>
  );
}
